import { combineEpics } from 'redux-observable';
import {initAfterLogin} from './loginEpic';
import {handleAddEventFulfilled} from './addEventEpic';
import {handleEditEventFulfilled} from './editEventEpic';
import {handleGetEventInfoFulfilled} from './getEventInfoEpic';
import {handleAsyncActionPending} from './asyncActionEpic';
import {handleAsyncActionFinished} from './asyncActionEpic';
import {handleAddTemplateFulfilled} from './addTemplateEpic';
import {handleMoveSongPostion} from './moveSongPositionEpic';
import {handleGetCategoryRecommendationSongsFulfilled} from './getCategoryRecommendationSongsEpic';
import {handleEditEventSongsFulfilled} from './editEventSongsEpic';
import {handleFlagEventSongsFulfilled} from './flagEventSongsEpic';
import {handleDeleteEventFulfilled} from './deleteEventEpic';
import {handleDeleteTemplateFulfilled} from './deleteTemplateEpic';
import{handleSetBranchHostPermissionFulfilled} from './setBranchHostPermissionEpic';
import{handleCreateEventDeepLinkFulfilled} from './createEventDeepLinkEpic';
import {handleAddEventSpecialSongFulfilled} from './addEventSpecialSongEpic'
import {handleUploadPicsToUserGalleryFulfilled} from './uploadPicsToUserGalleryEpic';
import {handleEditTemplateFulfilled} from './editTemplateEpic'

//import {initAfterLogin, initAfterRestore} from './loginEpic';

const allEpics = combineEpics(
   handleAsyncActionPending, handleAsyncActionFinished, initAfterLogin,
   handleAddEventFulfilled, handleGetEventInfoFulfilled, handleEditEventFulfilled,
   handleAddTemplateFulfilled, handleMoveSongPostion, handleGetCategoryRecommendationSongsFulfilled,
   handleEditEventSongsFulfilled, handleFlagEventSongsFulfilled, handleDeleteEventFulfilled,
   handleDeleteTemplateFulfilled, handleSetBranchHostPermissionFulfilled, handleCreateEventDeepLinkFulfilled,
   handleAddEventSpecialSongFulfilled, handleUploadPicsToUserGalleryFulfilled, handleEditTemplateFulfilled
);

export default allEpics;

/*export default combineEpics(
   initAfterLogin
);*/



// WEBPACK FOOTER //
// ./src/epics/index.js